export enum AssociationType {
    ATTACH = 'attach',
    DETACH = 'detach',
}
